import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { CloseOutlined } from '@ant-design/icons';
import QRcode from 'qrcode.react';
import { Utils } from '../../../tools/utils';
import { queryMerchantsAgreementStatus, getProcess } from '../api';
import newUser from './img/new-user.png';
import oldUser from './img/old-user.png';
import './index.less';

export const merchantsType = {
    '新商户': '1',
    '公转私商户': '2',
    '协议到期商户': '3',
    '历史团队版商户': '4',
    '拒绝签署商户': '5',
    '取消下发协议商户': '6',
    '1': '新商户',
    '2': '公转私商户',
    '3': '协议到期商户',
    '4': '历史团队版商户',
    '5': '拒绝签署商户',
    '6': '取消下发协议商户',
};

export const agreementOrRejection = {
    '待签署': '1',
    '已经签署': '2',
    '拒绝签署': '3'
};

export const publicOrPrivate = {
    '对公商户': '1',
    '对私商户': '0',
};

export const topResponsiblePerson = {
    '是顶级负责人': 'Y',
    '不是顶级负责人': 'N'
}

const dateType = {
    '内容模版': '0',
    '日期': '1'
}
//到期提示
export const remindInfo = () => {
    Modal.info({
        title: '提示',
        centered: true,
        content: '您的团队协议已到期，无法进行出单，请联系您的商务伙伴',
        maskClosable: true,
        okText: '确认',
    });
};
function Index(props) {
    const { show, isClose, typeAgreement, protocolDialogClosed, token, date } = props;
    const [timer, setTimer] = useState(0);
    useEffect(() => {
        if (show) {
            getRealNameAuthentication();
        }
    }, [show]);
    const handleCancel = () => {
        protocolDialogClosed(agreementOrRejection.待签署);
    }
    const getRealNameAuthentication = () => {
        let t = setTimeout(() => {
            queryMerchantsAgreementStatus(Utils.getOrgId(), Utils.getUserId()).then((res) => {
                const { data } = res;
                if (data.status === 200 && data.data.signAgreementType == agreementOrRejection.已经签署) {
                    protocolDialogClosed(agreementOrRejection.已经签署);
                    clearTimeout(timer)
                    return;
                } else {
                    getRealNameAuthentication();//递归
                }
            })
        }, 1500);
        setTimer(t);
    }
    const cluesText = (date, type) => {
        if (!date) return '';
        if (type === dateType.内容模版) {
            let contOldY = date.slice(0, 4);
            let contOldM = date.slice(5, 7);
            let contOldD = date.slice(8, 10);
            let contNewDate = new Date(`${contOldY}-${contOldM}-${contOldD}`);
            let contY = contNewDate.getFullYear();
            let contM = contNewDate.getMonth() + 1 < 10 ? '0' + (contNewDate.getMonth() + 1) : (contNewDate.getMonth() + 1);
            let contD = contNewDate.getDate() < 10 ? ('0' + contNewDate.getDate()) : contNewDate.getDate();
            return `【${contY}】年【${contM}】月【${contD}】日`;
        } else {
            let newDate = new Date(date);
            let Y = newDate.getFullYear();
            let M = newDate.getMonth() + 1 < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
            let D = newDate.getDate() < 10 ? ('0' + newDate.getDate()) : newDate.getDate();
            return `${Y}年${M}月${D}日`;
        }

    }
    const getContent = () => {
        if (typeAgreement === merchantsType.新商户) {
            return <p className='provisions'>依据平台规定，需要您扫描下方二维码确认团队协议内容并签字，<span style={{ 'color': '#1990FF' }}>否则将无法进行展业</span>。</p>
        }
        else if (typeAgreement === merchantsType.公转私商户) {
            return <p className='provisions'>依据平台规定，需要您扫描下方二维码确认团队协议内容并签字，<span style={{ 'color': '#1990FF' }}>否则将无法出新单</span>，历史保单仍可进行续期/续保/提现操作。</p>
        } else {
            return <p className='provisions'>依据平台规定，需要您在<span style={{ 'color': '#1990FF' }}>{cluesText(date, dateType.日期)}前</span>扫描下方二维码确认团队协议内容并签字，<span style={{ 'color': '#1990FF' }}>否则将无法出新单</span>，历史保单仍可进行续期/续保/提现操作。</p>
        }
    }
    return (
        <div>
            <Modal
                open={show}
                title=''
                width={600}
                height={470}
                maskClosable={false}
                keyboard={false}
                closable={true}
                wrapClassName='modal'
                footer={null}
                zIndex={9999}
                centered={true}
            >
                <div className='modal-code'>
                    {
                        typeAgreement === merchantsType.新商户 ? <img style={{ 'position': 'absolute', 'bottom': '0', 'left': '-24px', 'width': '160px', 'height': '236px' }} src={newUser}></img> : <img style={{ 'position': 'absolute', 'bottom': '0', 'right': '-12px', 'width': '185px', 'height': '216px' }} src={oldUser}></img>
                    }
                    <div className='instructions'>
                        {
                            typeAgreement != merchantsType.新商户 ? <CloseOutlined style={{ 'fontSize': '18px', 'position': 'absolute', 'top': '30px', 'right': '30px' }} onClick={() => { handleCancel() }} /> : null
                        }
                        <div className='content'>
                            <h2>亲爱的平台管理员</h2>
                            {getContent()}
                            <p className='Thank'>感谢您的支持和配合！</p>
                        </div>
                    </div>
                    <div className='modal-code-content'>
                        <div className='code-content'>
                            <QRcode value={getProcess(Utils.getUserId(), Utils.getOrgId())} size={112} level={'M'} />
                            <p>请使用手机扫描二维码进行实名认证与协议签署</p>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

Index.propTypes = {
    show: PropTypes.bool.isRequired,
    isClose: PropTypes.bool.isRequired,
    typeAgreement: PropTypes.string.isRequired,
    protocolDialogClosed: PropTypes.func.isRequired,
    date: PropTypes.string,
};

function mapState(state) {
    return {
        token: state.token,
    }
};

export default connect(mapState)(Index);